var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.5C18 8.74264 15.3137 9.75 12 9.75C8.68629 9.75 6 8.74264 6 7.5M18 7.5C18 6.25736 15.3137 5.25 12 5.25C8.68629 5.25 6 6.25736 6 7.5M18 7.5V12M6 7.5V12M6 12C6 12.5967 6.63214 13.169 7.75736 13.591C8.88258 14.0129 10.4087 14.25 12 14.25C13.5913 14.25 15.1174 14.0129 16.2426 13.591C17.3679 13.169 18 12.5967 18 12M6 12V16.5C6 17.0967 6.63214 17.669 7.75736 18.091C8.88258 18.5129 10.4087 18.75 12 18.75C13.5913 18.75 15.1174 18.5129 16.2426 18.091C17.3679 17.669 18 17.0967 18 16.5V12",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.e93838f12901d63259fbc0270f89bdad.svg";
export { ForwardRef as ReactComponent };